module.exports = __webpack_public_path__ + "img/radisson-res.f1977319.png";